var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFiles = function SvgFiles(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 65 65"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M30.42 8.712a8.29 8.29 0 0 0 7.712 5.248h9.6a16.86 16.86 0 0 1 14.816 8.8A17.63 17.63 0 0 0 44.852 6.184H29.3z",
    opacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M47.604 13.96h-9.6a8.29 8.29 0 0 1-7.712-5.248l-.992-2.72A8.35 8.35 0 0 0 21.588.744h-6.4A14.69 14.69 0 0 0 .5 15.464V48.04A16.93 16.93 0 0 0 17.396 65h30.208A16.93 16.93 0 0 0 64.5 48.04V30.92a16.93 16.93 0 0 0-16.896-16.96m-3.2 20.32-9.92 12.992a2.34 2.34 0 0 1-1.76.896 2.37 2.37 0 0 1-1.76-.832L23.7 38.76a2.304 2.304 0 0 1 3.52-2.944l5.28 6.528 8.192-10.72a2.27 2.27 0 0 1 3.2-.448 2.336 2.336 0 0 1 .448 3.104z"
  })));
};
export default SvgFiles;